import {Action} from "@ngrx/store";

export const RUN_SECURITY_SCAN: string = '[security] Run Security Scan';
export const RUN_SECURITY_SCAN_SUCCESS: string = '[security] Run Security Scan Success';
export const RUN_SECURITY_SCAN_FAIL: string = '[security] Run Security Scan Fail';

export const LOAD_SECURITY_SCAN: string = '[security] Load Security Scan';
export const LOAD_SECURITY_SCAN_SUCCESS: string = '[security] Load Security Scan Success';
export const LOAD_SECURITY_SCAN_FAIL: string = '[security] Load Security Scan Fail';

export const LOAD_SECURITY_IGNORED_ISSUES: string = '[security] Load Security Ignored Issues';
export const LOAD_SECURITY_IGNORED_ISSUES_SUCCESS: string = '[security] Load Security Ignored Issues Success';
export const LOAD_SECURITY_IGNORED_ISSUES_FAIL: string = '[security] Load Security Ignored Issues Fail';

export const IGNORE_SECURITY_ISSUE: string = '[security] Ignore Security Issue';
export const RESTORE_SECURITY_ISSUE: string = '[security] Restore Security Issue';
export const RESTORE_SECURITY_FILE: string = '[security] Restore Security File';

export const LOAD_SECURITY_SETTINGS: string = '[security] Load Security Settings';
export const LOAD_SECURITY_SETTINGS_SUCCESS: string = '[security] Load Security Settings Success';
export const LOAD_SECURITY_SETTINGS_FAIL: string = '[security] Load Security Settings Fail';

export const LOAD_SECURITY_SCHEDULE: string = '[security] Load Security Schedule';
export const LOAD_SECURITY_SCHEDULE_SUCCESS: string = '[security] Load Security Schedule Success';
export const LOAD_SECURITY_SCHEDULE_FAIL: string = '[security] Load Security Schedule Fail';

export const LOAD_SECURITY_AUTOUPDATE: string = '[security] Load Autoupdate Schedule';
export const LOAD_SECURITY_AUTOUPDATE_SUCCESS: string = '[security] Load Security Autoupdate Success';
export const LOAD_SECURITY_AUTOUPDATE_FAIL: string = '[security] Load Security Autoupdate Fail';

export const UPDATE_SECURITY_SETTINGS: string = '[security] Update Security Settings';
export const UPDATE_SECURITY_SETTINGS_SUCCESS: string = '[security] Update Security Settings Success';
export const UPDATE_SECURITY_SETTINGS_FAIL: string = '[security] Update Security Settings Fail';

export const UPDATE_SECURITY_SCHEDULE: string = '[security] Update Security Schedule';
export const UPDATE_SECURITY_SCHEDULE_SUCCESS: string = '[security] Update Security Schedule Success';
export const UPDATE_SECURITY_SCHEDULE_FAIL: string = '[security] Update Security Schedule Fail';

export const UPDATE_SECURITY_AUTOUPDATE: string = '[security] Update Security Autoupdate';
export const UPDATE_SECURITY_AUTOUPDATE_SUCCESS: string = '[security] Update Security Autoupdate Success';
export const UPDATE_SECURITY_AUTOUPDATE_FAIL: string = '[security] Update Security Autoupdate Fail';

export class RunSecurityScan implements Action {

  readonly type: string = RUN_SECURITY_SCAN;
  constructor(public payload: number) {}

}

export class RunSecurityScanSuccess implements Action {

  readonly type: string = RUN_SECURITY_SCAN_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securityScan: any
  }) {}

}

export class RunSecurityScanFail implements Action {

  readonly type: string = RUN_SECURITY_SCAN_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class LoadSecurityScan implements Action {

  readonly type: string = LOAD_SECURITY_SCAN;
  constructor(public payload: number) {}

}

export class LoadSecurityScanSuccess implements Action {

  readonly type: string = LOAD_SECURITY_SCAN_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securityScan: any
  }) {}

}

export class LoadSecurityScanFail implements Action {

  readonly type: string = LOAD_SECURITY_SCAN_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class LoadSecurityIgnoredIssues implements Action {

  readonly type: string = LOAD_SECURITY_IGNORED_ISSUES;
  constructor(public payload: number) {}

}

export class LoadSecurityIgnoredIssuesSuccess implements Action {

  readonly type: string = LOAD_SECURITY_IGNORED_ISSUES_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securityIgnoredIssues: any
  }) {}

}

export class LoadSecurityIgnoredIssuesFail implements Action {

  readonly type: string = LOAD_SECURITY_IGNORED_ISSUES_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class IgnoreSecurityIssue implements Action {

  readonly type: string = IGNORE_SECURITY_ISSUE;
  constructor(public payload: {
    websiteId: number,
    issueData: any
  }) {}

}

export class RestoreSecurityIssue implements Action {

  readonly type: string = RESTORE_SECURITY_ISSUE;
  constructor(public payload: {
    websiteId: number,
    issueData: any
  }) {}

}

export class RestoreSecurityFile implements Action {

  readonly type: string = RESTORE_SECURITY_FILE;
  constructor(public payload: {
    websiteId: number
  }) {}

}

export class LoadSecuritySettings implements Action {

  readonly type: string = LOAD_SECURITY_SETTINGS;
  constructor(public payload: number) {}

}

export class LoadSecuritySettingsSuccess implements Action {

  readonly type: string = LOAD_SECURITY_SETTINGS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securitySettings: any
  }) {}

}

export class LoadSecuritySettingsFail implements Action {

  readonly type: string = LOAD_SECURITY_SETTINGS_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class LoadSecuritySchedule implements Action {

  readonly type: string = LOAD_SECURITY_SCHEDULE;
  constructor(public payload: number) {}

}

export class LoadSecurityScheduleSuccess implements Action {

  readonly type: string = LOAD_SECURITY_SCHEDULE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securitySchedule: any
  }) {}

}

export class LoadSecurityScheduleFail implements Action {

  readonly type: string = LOAD_SECURITY_SCHEDULE_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class LoadSecurityAutoupdate implements Action {

  readonly type: string = LOAD_SECURITY_AUTOUPDATE;
  constructor(public payload: number) {}

}

export class LoadSecurityAutoupdateSuccess implements Action {

  readonly type: string = LOAD_SECURITY_AUTOUPDATE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securityAutoupdate: any
  }) {}

}

export class LoadSecurityAutoupdateFail implements Action {

  readonly type: string = LOAD_SECURITY_AUTOUPDATE_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class UpdateSecuritySettings implements Action {

  readonly type: string = UPDATE_SECURITY_SETTINGS;
  constructor(public payload: {
    websiteId: number,
    settings: any
  }) {}

}

export class UpdateSecuritySettingsSuccess implements Action {

  readonly type: string = UPDATE_SECURITY_SETTINGS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securitySettings: any
  }) {}

}

export class UpdateSecuritySettingsFail implements Action {

  readonly type: string = UPDATE_SECURITY_SETTINGS_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class UpdateSecuritySchedule implements Action {

  readonly type: string = UPDATE_SECURITY_SCHEDULE;
  constructor(public payload: {
    websiteId: number,
    securitySchedule: any
  }) {}

}

export class UpdateSecurityScheduleSuccess implements Action {

  readonly type: string = UPDATE_SECURITY_SCHEDULE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securitySchedule: any
  }) {}

}

export class UpdateSecurityScheduleFail implements Action {

  readonly type: string = UPDATE_SECURITY_SCHEDULE_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export class UpdateSecurityAutoupdate implements Action {

  readonly type: string = UPDATE_SECURITY_AUTOUPDATE;
  constructor(public payload: {
    websiteId: number,
    securityAutoupdate: any
  }) {}

}

export class UpdateSecurityAutoupdateSuccess implements Action {

  readonly type: string = UPDATE_SECURITY_AUTOUPDATE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    securityAutoupdate: any
  }) {}

}

export class UpdateSecurityAutoupdateFail implements Action {

  readonly type: string = UPDATE_SECURITY_AUTOUPDATE_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export type SecurityAction = RunSecurityScan | RunSecurityScanSuccess | RunSecurityScanFail
  | LoadSecurityScan | LoadSecurityScanSuccess | LoadSecurityScanFail
  | LoadSecurityIgnoredIssues | LoadSecurityIgnoredIssuesSuccess | LoadSecurityIgnoredIssuesFail
  | IgnoreSecurityIssue | RestoreSecurityIssue | RestoreSecurityFile
  | LoadSecuritySettings | LoadSecuritySettingsSuccess | LoadSecuritySettingsFail
  | LoadSecuritySchedule | LoadSecurityScheduleSuccess | LoadSecurityScheduleFail
  | UpdateSecuritySettings | UpdateSecuritySettingsSuccess | UpdateSecuritySettingsFail | UpdateSecuritySchedule | UpdateSecurityScheduleSuccess | UpdateSecurityScheduleFail | UpdateSecurityAutoupdate | UpdateSecurityAutoupdateSuccess | UpdateSecurityAutoupdateFail;
